import React from "react"

function AlignTop({ size }) {
    return (
        <svg viewBox="0 0 24 24" height={size}><path d="M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"></path></svg>
    )
}

export default AlignTop